import { Box } from '@mui/material';
import { useParams } from 'react-router-dom';
import { Header } from 'src/components/header';
import { ViewOnlyAlert } from 'src/components/viewOnlyAlert';
import { PATHS } from 'src/constants/paths';
import { useGetProjectConfig } from 'src/hooks';
import { ILocationGroup } from 'src/interfaces';
import { lang, useUserRole } from 'src/utils';

import { useLocationTimingPage } from './hooks/TimingLocationPage.hook';
import { LocationTimingsGrid } from './modules/locationTimingsGrid/LocationTimingsGrid';
import { LocationTimingsHeader } from './modules/locationTimingsHeader/LocationTimingsHeader';

export const TimingLocationPage = () => {
  const { locationCode = '' } = useParams();
  const {
    formMethods,
    isLoadingChannels,
    isLocationLoading,
    channelsData,
    locGroupDayparts,
    isLoadingLocGroupDayparts,
    updateSelectedLocationGroup,
    selectedLocationGroup,
    isDefaultLocationGroup,
  } = useLocationTimingPage(locationCode);
  const location = formMethods.getValues().location;
  const { isViewOnly, isOwnerOperator } = useUserRole();
  const { data: projectConfig, isLoading: isLoadingGlobalConfig } =
    useGetProjectConfig();
  const rbStoreIntegration = projectConfig?.rbStoreIntegration ?? false;

  return (
    <>
      <Box>
        {location && (
          <Header
            title={`${location?.hq?.name} timings `}
            actionBar={isViewOnly && <ViewOnlyAlert />}
            breadcrumbItems={[
              {
                label: !isOwnerOperator ? lang.locationGroup : lang.location,
                link: !isOwnerOperator
                  ? PATHS.LOCATION_GROUPS
                  : PATHS.OO_LOCATION_PAGE,
              },
              {
                label: location?.hq?.name as string,
              },
            ]}
          />
        )}
        {!isLoadingChannels &&
          !isLocationLoading &&
          !isLoadingLocGroupDayparts &&
          !isLoadingGlobalConfig &&
          locationCode && (
            <>
              <LocationTimingsHeader
                channelsData={channelsData as ILocationGroup[]}
                updateSelectedLocationGroup={updateSelectedLocationGroup}
                selectedLocationGroup={selectedLocationGroup as ILocationGroup}
                scheduleDaypartsAvailable={!!locGroupDayparts?.length}
                isDefaultLocationGroup={
                  selectedLocationGroup?.is_default || false
                }
                rbStoreIntegration={rbStoreIntegration}
              />
              {selectedLocationGroup &&
                locGroupDayparts &&
                locGroupDayparts.length > 0 && (
                  <LocationTimingsGrid
                    locationGroupData={selectedLocationGroup as ILocationGroup}
                    locGroupScheduleDayparts={locGroupDayparts}
                    isDefaultLocationGroup={isDefaultLocationGroup || false}
                    rbStoreIntegration={rbStoreIntegration}
                  />
                )}
            </>
          )}
      </Box>
    </>
  );
};
